import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../component/header";
import SearchFilter from "../component/search-filter";
import RowHeader from "../component/commom/row-header";
import { appRepo } from "../repo/app-repo";
import { Movie } from "../entry/server/movie";
import { ApiResponse } from "../lib/api";
import { MainPageData } from "../entry/server/movie";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import MovieCard from "../component/commom/movie-card";
import Footer from "../component/footer";
import Slider from "../component/parts/slider";
import AppLinksSection from "../component/parts/app-links-section";
import { ASSETS_BASE_URL } from "../utils/constants";
import "@/styles/movies-row.css";
import "@/styles/single-movie-section.css";
import loadingGif from "@public/img/loading.gif";
import imdbIcon from "@public/img/imdb.svg";
import playIcon from "@public/img/play.svg";
import summaryArrowIcon from "@public/img/arrow-left.svg";

export default function Home(): React.ReactElement {
  useDocumentTitle("صفحه اصلی");
  const [mainPageData, setMainPageData] = useState<ApiResponse<MainPageData> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(function () {
    appRepo.getHomePageData().then(function (res) {
      setMainPageData(res);
      setLoading(false);
    }).catch(function () {
      setLoading(false);
    });
  }, []);

  if (loading || !mainPageData) {
    return (
      <div className="page-loading">
        <img src={loadingGif} alt="loading" />
      </div>
    );
  }

  const data = mainPageData.data;

  return (
    <div id="top" className="min-h-screen bg-main-bg p-0">
      <div className="relative">
        <Header />
        {data && data.slider_movies && data.slider_movies.length > 0 && (
          <Slider movies={data.slider_movies} />
        )}
      </div>
      <SearchFilter />

      <div className="mt-8">
        {data &&
          data.rows.map(function (row, index) {
            if (row.type === "list") {
              return (
                <ListSection
                  key={"list-" + row.title + "-" + index}
                  title={row.title}
                  link={row.more_url}
                  items={row.movies ? row.movies : []}
                />
              );
            }

            if (row.type === "single" && row.movies && row.movies[0]) {
              return (
                <SingleMovieSection
                  key={"single-" + row.movies[0].id}
                  item={row.movies[0]}
                />
              );
            }

            if (row.type === "app_links") {
              return <AppLinksSection key={"app-links-" + index} />;
            }

            return null;
          })}
      </div>
      <Footer />
    </div>
  );
}

function SingleMovieSection(props: { item: Movie }): React.ReactElement | null {
  var item = props.item;
  if (!item) {
    return null;
  }

  var bannerSrc =
    item.banner && item.banner.indexOf("http") === 0
      ? item.banner
      : ASSETS_BASE_URL + (item.banner ? item.banner : "");
  var detailsHref = "/" + item.type + "/" + item.id + "/" + item.slug + "/";
  var playHref = "/player/" + item.id + (item.is_series ? "?season=1&episode=1" : "");
  var summary = item.summary ? item.summary.trim() : "";
  var ratingText = item.imdb_rate != null && item.imdb_rate > 0 ? String(item.imdb_rate) : "N/A";

  return (
    <section className="single-movie">
      <div
        className="single-movie__card"
        style={{ backgroundImage: "url(" + bannerSrc + ")" }}
      >
        <div className="single-movie__overlay" aria-hidden="true" />

        <div className="single-movie__content">
          <div className="single-movie__rating">
            <span>{ratingText}/10</span>
            <img src={imdbIcon} alt="IMDB" width={20} height={20} />
          </div>

          <h2 className="single-movie__title">
            {item.title} {item.year}
          </h2>

          {item.fa_title && (
            <p className="single-movie__fa-title">{item.fa_title}</p>
          )}

          <div className="single-movie__badges">
            <span className="single-movie__badge">{item.year}</span>
            {(item.genres ? item.genres : []).map(function (genre, gi) {
              return (
                <span className="single-movie__badge" key={genre + "-" + gi}>
                  {genre}
                </span>
              );
            })}
          </div>

          {summary && (
            <div className="single-movie__summary">
              <div className="single-movie__summary-head">
                <img src={summaryArrowIcon} alt="" width={16} height={16} />
                <span>خلاصه فیلم</span>
              </div>
              <p className="single-movie__summary-text">{summary}</p>
            </div>
          )}

          <div className="single-movie__actions">
            <Link to={playHref} className="single-movie__btn single-movie__btn--play">
              <img src={playIcon} alt="" width={20} height={20} />
              <span>پخش آنلاین</span>
            </Link>
            <Link to={detailsHref} className="single-movie__btn single-movie__btn--details">
              مشاهده جزئیات
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function ListSection(props: { title: string; link: string; items: Movie[] }): React.ReactElement {
  return (
    <section className="home-section">
      <RowHeader title={props.title} actionLink={props.link} actionLabel="مشاهده همه" />
      <div className="movies-row">
        {props.items.map(function (item) {
          var yearValue = item.year != null ? String(item.year) : "";
          var ratingValue = item.imdb_rate != null ? String(item.imdb_rate) : "0";
          return (
            <MovieCard
              key={item.id}
              id={item.id}
              slug={item.slug}
              type={item.type}
              title={item.title}
              updateText={item.update_text}
              year={yearValue}
              ratingValue={ratingValue}
              thumbnail={item.thumbnail}
              isDubbed={item.is_dubbed}
              isSubtitled={item.is_subbed}
              genres={item.genres ? item.genres : []}
            />
          );
        })}
      </div>
    </section>
  );
}
